import store from '@/app/app-state';

export const userRole = () => store.state.authState.authState.role;
